module.exports = __webpack_public_path__ + "static/media/Icon.587533d1.svg";